"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Components: true,
  postMessageWrapper: true,
  Wrappers: true,
  enableAuth: true,
  useAuth: true,
  Reducers: true
};
Object.defineProperty(exports, "postMessageWrapper", {
  enumerable: true,
  get: function get() {
    return _wrappers.postMessageWrapper;
  }
});
Object.defineProperty(exports, "Wrappers", {
  enumerable: true,
  get: function get() {
    return _wrappers["default"];
  }
});
Object.defineProperty(exports, "enableAuth", {
  enumerable: true,
  get: function get() {
    return _wrappers.enableAuth;
  }
});
Object.defineProperty(exports, "useAuth", {
  enumerable: true,
  get: function get() {
    return _wrappers.useAuth;
  }
});
Object.defineProperty(exports, "Reducers", {
  enumerable: true,
  get: function get() {
    return _reducers["default"];
  }
});
exports.Components = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = _interopRequireDefault(require("./components"));

var _wrappers = _interopRequireWildcard(require("./wrappers"));

var _reducers = _interopRequireDefault(require("./reducers"));

var _api = require("./api");

Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _api[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _api[key];
    }
  });
});

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AmsManager = function AmsManager(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "max-w-7xl mx-auto h-full flex flex-col" : _ref$className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, children);
};

var Components = _objectSpread(_objectSpread({}, _components["default"]), {}, {
  "ams-manager": (0, _wrappers.amsManager)(AmsManager)
});

exports.Components = Components;